module.exports = __webpack_public_path__ + "18797dccd6f609f92f5c46006e15b582.svg";